import {extendCrudApiByHousehold} from '@/utils/api.js';

const shoppingListApi = extendCrudApiByHousehold({
  entityNameSingular: 'ShoppingListEntry',
  entityNamePlural: 'ShoppingListEntries',
  entityPath: 'shopping-list-entries',
  extraTags: ['MealPlanEntries', 'Recipes'],
  extraEndpoints: (builder) => ({
    archiveAllShoppingListEntries: builder.mutation({
      query: ({ householdId }) => ({
        url: `/h/${householdId}/shopping-list-entries/.archive`,
        method: 'POST',
        params: { only_bought: 'true' },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShoppingListEntries', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    deleteBoughtShoppingListEntries: builder.mutation({
      query: ({ householdId }) => ({
        url: `/h/${householdId}/shopping-list-entries/.delete-bought`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShoppingListEntries', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    setIsBoughtShoppingListEntries: builder.mutation({
      query: ({ householdId, isBought }) => ({
        url: `/h/${householdId}/shopping-list-entries/.set-is-bought`,
        method: 'POST',
        body: { is_bought: isBought },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShoppingListEntries', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    unarchiveShoppingListEntries: builder.mutation({
      query: ({ householdId, entryIds }) => ({
        url: `/h/${householdId}/shopping-list-entries/.unarchive`,
        method: 'POST',
        body: { entry_ids: entryIds },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShoppingListEntries', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    restoreDeletedShoppingListEntries: builder.mutation({
      query: ({ householdId, entryIds }) => ({
        url: `/h/${householdId}/shopping-list-entries/.restore-deleted`,
        method: 'POST',
        body: { entry_ids: entryIds },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShoppingListEntries', id: 'LIST', householdId: arg.householdId }
      ],
    }),
    getFromMealPlan: builder.query({
      query: ({ householdId, fromDate, toDate }) => ({
        url: `/h/${householdId}/shopping-list-entries/from-meal-plan`,
        method: 'GET',
        params: {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getFromRecipe: builder.query({
      query: ({ householdId, recipeId }) => ({
        url: `/h/${householdId}/shopping-list-entries/from-recipe/${recipeId}`,
        method: 'GET',
      }),
      providesTags: (result, error, arg) => [
        { type: 'Recipes', id: arg.recipeId, householdId: arg.householdId }
      ],
    }),
    bulkAdd: builder.mutation({
      query: ({ householdId, entries }) => ({
        url: `/h/${householdId}/shopping-list-entries/.bulk-add`,
        method: 'POST',
        body: { entries },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'ShoppingListEntries', id: 'LIST', householdId: arg.householdId }
      ],
    }),
  }),
});

export const {
  useGetShoppingListEntriesQuery,
  useGetShoppingListEntryQuery,
  useUpdateShoppingListEntryMutation,
  usePatchShoppingListEntryMutation,
  useDeleteShoppingListEntryMutation,
  useCreateShoppingListEntryMutation,
  useArchiveAllShoppingListEntriesMutation,
  useDeleteBoughtShoppingListEntriesMutation,  
  useSetIsBoughtShoppingListEntriesMutation,
  useUnarchiveShoppingListEntriesMutation,
  useRestoreDeletedShoppingListEntriesMutation,
  useGetFromMealPlanQuery,
  useGetFromRecipeQuery,
  useBulkAddMutation,
} = shoppingListApi;

